import React from 'react';

import { BaseIconProps } from '.';

export const CheckmarkCircle = ({ fill }: BaseIconProps) => (
  <g id="g337" transform="scale(54)" strokeWidth="0.01851852">
    <path
      fill={fill}
      strokeWidth="0.01851852"
      d="m 2,10 c 0,4.43 3.57,8 8,8 4.43,0 8,-3.57 8,-8 C 18,5.57 14.43,2 10,2 5.57,2 2,5.57 2,10 Z m 18,0 C 20,15.511 15.511,20 10,20 4.489,20 0,15.511 0,10 0,4.489 4.489,0 10,0 15.511,0 20,4.489 20,10 Z M 15.414,7.414 7.707,15.121 4,11.414 5.414,10 7.707,12.293 14,6 Z"
    />
  </g>
);
